import { Component, ElementRef, OnInit, ViewChild, NgZone } from '@angular/core';
import 'chartjs-plugin-datalabels';
import { PortalService } from 'src/services/portal.service';
import * as _ from 'lodash';

@Component({
    selector: 'painel-insumos-component',
    templateUrl: 'painel-insumos-component.html',
    styleUrls: ['painel-insumos-component.scss'],
})
export class PainelInsumosComponent implements OnInit {

    @ViewChild('elSelect', {static: true}) elSelect;

    casosConfirmados = {
        total: null,
        homens: '55%',
        mulheres: '45%',
        titulo: 'Casos Confirmados'
    };

    label = 'itens';
    listaCidades: any[] = [];
    listaInsumos: any[] = [];
    map: any[] = [];

    geral: any = {};
    mapLoading = true;
    listMap = true;
    filtro: any = {
        filter: '',
        range: []
    };

    selectedCity = 'Brasil';
    labelSelected = 'Brasil';

    rangeColors: any[] = [];

    constructor(private portal: PortalService,
                private zone: NgZone) {
    }

    async ngOnInit() {
        console.log('ngOnInit -> PainelInsumosComponent');
        this.getStructure();
        this.loadInsumos();
    }

    filtrar(data: any) {
        this.listMap = false;
        this.mapLoading = true;

        if (data && data.card) {
            this.filtro = data.card;
        }

        const self = this;
        setTimeout(() => {
            self.listMap = true;
            self.mapLoading = false;
        }, 1000);
    }

    openSelect() {
        this.elSelect.open();
    }

    async loadInsumos() {
        this.map = await this.portal.getCDN('PortalMapa');
        // @ts-ignore
        this.geral = await this.portal.postInsumosCDN('PortalInsumo');

        this.loadGeral()

        this.filtro = this.listaInsumos[0];
        const self = this;

        this.listaCidades = this.geral.hits.hits.map(val => {
            const item = _.find(self.map, {nome: val._source.no_uf});
            const date = val._source.atualizacao_insumos.split('-');

            item.doses_distribuidas = val._source.doses_distribuidas;
            item.luava_proc_n_cirurgico = val._source.luava_proc_n_cirurgico;
            item.avental = val._source.avental;
            item.uti_adulto = val._source.uti_adulto;
            item.teste_rapido = val._source.teste_rapido;
            item.sg_uf = val._source.sg_uf;
            item.alcool_etilico_100ml = val._source.alcool_etilico_100ml;
            item.alcool_etilico_500ml = val._source.alcool_etilico_500ml;
            item.alcool_etilico = val._source.alcool_etilico_100ml + val._source.alcool_etilico_500ml;
            item.touca_hosp = val._source.touca_hosp;
            item.sapatilha = val._source.sapatilha;
            item.sapatilha_toucas = val._source.sapatilha + val._source.touca_hosp;
            item.mascara_3_camadas = val._source.mascara_3_camadas;
            item.oculos_protecao = val._source.oculos_protecao;
            item.uti_adulto = val._source.uti_adulto;
            item.pop_2019 = val._source.pop_2019;
            item.doses_aplicadas = val._source.doses_aplicadas;
            item.atualizacao_insumos = date[2] + '/' + date[1];
            return item;
        });
        console.log(this.listaCidades)
        this.mapLoading = false;
    }

    loadGeral() {
        this.listaInsumos[0].total = this.geral.aggregations.uti_adulto.value.toLocaleString();
        this.listaInsumos[1].total = (this.geral.aggregations.alcool_etilico100.value + this.geral.aggregations.alcool_etilico500.value).toLocaleString();
        this.listaInsumos[2].total = this.geral.aggregations.luava_proc_n_cirurgico.value.toLocaleString();
        this.listaInsumos[3].total = this.geral.aggregations.uti_adulto.value.toLocaleString();
        this.listaInsumos[4].total = this.geral.aggregations.avental.value.toLocaleString();
        this.listaInsumos[5].total = this.geral.aggregations.oculos_protecao.value.toLocaleString();
        this.listaInsumos[6].total = this.geral.aggregations.mascara_3_camadas.value.toLocaleString();
        this.listaInsumos[7].total = this.geral.aggregations.teste_rapido.value.toLocaleString();
        this.listaInsumos[8].total = (this.geral.aggregations.sapatilha.value + this.geral.aggregations.touca_hosp.value).toLocaleString();
    }

    getValue (item) {
        return JSON.stringify(item)
    }

    selectItem() {
        if(this.selectedCity == 'Brasil') {
            this.labelSelected = 'Brasil';
            this.loadGeral()
        } else {
            let item = JSON.parse(this.selectedCity);
            this.labelSelected = item.nome;
            this.listaInsumos[0].total = item.uti_adulto.toLocaleString();
            this.listaInsumos[1].total = item.alcool_etilico.toLocaleString();
            this.listaInsumos[2].total = item.luava_proc_n_cirurgico.toLocaleString();
            this.listaInsumos[3].total = item.uti_adulto.toLocaleString();
            this.listaInsumos[4].total = item.avental.toLocaleString();
            this.listaInsumos[5].total = item.oculos_protecao.toLocaleString();
            this.listaInsumos[6].total = item.mascara_3_camadas.toLocaleString();
            this.listaInsumos[7].total = item.teste_rapido.toLocaleString();
            this.listaInsumos[8].total = item.sapatilha_toucas.toLocaleString();
        }
    }

    async getStructure() {

        this.rangeColors = [
            {
                color: '#D9DFFD',
                range: 0
            },
            {
                color: '#BCC4EB',
                range: 1000
            },
            {
                color: '#9AA4E1',
                range: 2000
            },
            {
                color: '#7584D8',
                range: 10000
            },
            {
                color: '#556CE7',
                range: 20000
            },
            {
                color: '#4961E7',
                range: 50000
            },
            {
                color: '#1e40ea',
                range: 100000
            }
        ];

        this.listaInsumos = [
            {
                titulo: 'Leitos',
                total: null,
                icone: '/assets/imgs/icon-maca.svg',
                filter: 'uti_adulto',
                range: this.rangeColors
            },
            {
                titulo: 'Álcool 100/500ml',
                total: null,
                icone: '/assets/imgs/icon-garrafa.svg',
                filter: 'alcool_etilico',
                range: this.rangeColors
            },
            {
                titulo: 'Luvas',
                total: null,
                icone: '/assets/imgs/icon-luva.svg',
                filter: 'luava_proc_n_cirurgico',
                range: this.rangeColors
            },
            {
                titulo: 'Leitos de UTI adulto',
                total: null,
                icone: '/assets/imgs/icon-maca-pink.svg',
                filter: 'uti_adulto',
                range: this.rangeColors
            },
            {
                titulo: 'Aventais',
                total: null,
                icone: '/assets/imgs/icon-camisa.svg',
                filter: 'avental',
                range: this.rangeColors
            },
            {
                titulo: 'Óculos de proteção',
                total: null,
                icone: '/assets/imgs/icon-oculos.svg',
                filter: 'oculos_protecao',
                range: this.rangeColors
            },
            {
                titulo: 'Máscara cirúrgica',
                total: null,
                icone: '/assets/imgs/icon-mascara.svg',
                filter: 'mascara_3_camadas',
                range: this.rangeColors
            },
            {
                titulo: 'Kit teste rápido',
                total: null,
                icone: '/assets/imgs/icon-lista.svg',
                filter: 'teste_rapido',
                range: this.rangeColors
            },
            {
                titulo: 'Sapatilhas e toucas',
                total: null,
                icone: '/assets/imgs/icon-enfermeiro.svg',
                filter: 'sapatilha_toucas',
                range: this.rangeColors
            },
        ];
    }
}
